import { ReactNode } from 'react';

import clsx from 'clsx';

import Button from '@ui/components/Button';
import IconCross from '@ui/components/icons/IconCross';

export interface PopupProps {
  className?: string;
  children?: ReactNode;
  size?: 'regular' | 'big';
  type?: 'regular' | 'tooltip';
}
const Popup = ({
  children,
  className,
  size = 'regular',
  type = 'regular',
}: PopupProps) => (
  <div
    className={clsx(
      'w-full rounded-[40px] bg-brand-white-100 shadow-popup transition-all duration-300 motion-reduce:transition-none md:w-auto',
      size === 'regular' && 'flex flex-wrap p-4 md:p-6',
      size === 'big' &&
        'relative grid grid-cols-4 px-4 pb-4 pt-[72px] md:grid-cols-5 md:p-[40px]',
      className,
    )}
    onClick={(event) => {
      event.preventDefault();
      event.stopPropagation();
    }}
  >
    {size === 'big' && (
      <Button
        type="close"
        addonBefore={<IconCross className="fill-brand-primary-100" />}
        classNameWrapper="absolute right-4 top-4 md:hidden"
      />
    )}
    {children}
    {type === 'tooltip' && (
      <div className="absolute left-1/2 top-full hidden h-[25px] w-full -translate-x-1/2 overflow-hidden after:absolute after:left-1/2 after:top-0 after:h-[20px] after:w-[20px] after:-translate-x-1/2 after:-translate-y-1/2 after:rotate-45 after:bg-brand-white-100 md:block" />
    )}
  </div>
);

export default Popup;
